export const getDisplayName = (element) => {
    const type = element.type;
    const component = type;
    return component.displayName;
};
